import React, {useContext, useState} from 'react';
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import ApiDatabase from 'server'
import {toast} from "react-toastify";
import usefetchdata from "hooks/usefetchdata";
import UseContext from "hooks/useContext";


const Iban = () => {
    const {toggle} = useModal()
    const {tempWorkerData}=usefetchdata()
    const {language,refreshLoadWorker} = UseContext()
    const [iban, setIban] = useState(tempWorkerData?.bank?.iban ??'')

    const handleChange = e => {
        e.preventDefault()
        setIban(e.target.value)
    }

    const handleSubmit = e => {
        e.preventDefault()
        ApiDatabase.postUpdateIban(
            {
                token: localStorage.getItem('xsrfToken'),
                iban:iban
            },
            (data) => {
                refreshLoadWorker()
                toast.success('L\'identité bancaire est ajoutée.')
            },
            (err) => {
                if (err.name !== "CanceledError") {
                    toast.error('Un problème survenu')
                    console.log(err)
                }
            })
    }
    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                {language.getValue('justify.m_iban_title_c')}
            </Modalheader>
            <ModalBody>
                <form className='grid grid-cols-2 gap-2'>
                    <div className="col-span-2">
                        <label
                            htmlFor="iban"
                            className="block ft-sm font-medium  text-gray-500"
                        >
                            Iban
                        </label>
                        <div className=" text-gray-500">
                            <input
                                name="iban"
                                pattern="([A-Z])[\w+.]{1,}"
                                value={iban}
                                onChange={handleChange}
                                className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-400 border rounded-lg "
                                type="text"
                                required
                            />
                        </div>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'}
                        onClick={toggle}>Annuler</Button>
                <Button size={'LG'} onClick={handleSubmit}>Confirmer</Button>
            </ModalFooter>
        </>
    );
};

export default Iban;